export default "__VITE_ASSET__CSE8WZy0__"